import { SiteEditorContent } from "./SiteEditorContent";

export function SiteView() {
  return (
    <div className="flex h-full w-full flex-col overflow-hidden" id="site-page-view">
      <SiteEditorContent />
    </div>
  );
}

export default SiteView;
